module.exports = __webpack_public_path__ + "static/media/baby-sitting@2x.5fdac64c.jpg";